<div class="containers">
  <app-utils-tabs [type]="'Containers'"></app-utils-tabs>
</div>
